// slices/passwordWarningSlice.js
import { createSlice } from "@reduxjs/toolkit";

const passwordWarningSlice = createSlice({
  name: "passwordWarning",
  initialState: {
    show: false,
    response: null,
    navigate: null,
    setLoading: null,
  },
  reducers: {
    showPasswordWarning: (state, action) => {
      state.show = true;
      state.response = action.payload.response;
      state.navigate = action.payload.navigate;
      state.setLoading = action.payload.setLoading;
    },
    hidePasswordWarning: (state) => {
      state.show = false;
      state.response = null;
      state.navigate = null;
      state.setLoading = null;
    },
  },
});

export const { showPasswordWarning, hidePasswordWarning } = passwordWarningSlice.actions;
export default passwordWarningSlice.reducer;
